var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 2.9375,
    width: 35.25,
    height: 41.125,
    rx: 2,
    fill: "#2FB776"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 33.7812H47V42.0625C47 43.1671 46.1046 44.0625 45 44.0625H13.75C12.6454 44.0625 11.75 43.1671 11.75 42.0625V33.7812Z",
    fill: "url(#paint0_linear_6410_180169)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.375,
    y: 23.5,
    width: 17.625,
    height: 10.2812,
    fill: "#229C5B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.375,
    y: 13.2188,
    width: 17.625,
    height: 10.2812,
    fill: "#27AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 4.9375C11.75 3.83293 12.6454 2.9375 13.75 2.9375H29.375V13.2188H11.75V4.9375Z",
    fill: "#1D854F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 13.2188,
    width: 17.625,
    height: 10.2812,
    fill: "#197B43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 23.5,
    width: 17.625,
    height: 10.2812,
    fill: "#1B5B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 16.2188C11.75 14.5619 13.0931 13.2188 14.75 13.2188H26.375C28.0319 13.2188 29.375 14.5619 29.375 16.2188V36.6562C29.375 38.3131 28.0319 39.6562 26.375 39.6562H11.75V16.2188Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 10.2812,
    width: 26.4375,
    height: 26.4375,
    rx: 2,
    fill: "url(#paint1_linear_6410_180169)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0938 30.8438L14.955 23.3531L18.912 16.1562H15.6818L13.2389 20.7513L10.8364 16.1562H7.50526L11.4825 23.3531L7.34375 30.8438H10.574L13.1784 25.9759L15.7626 30.8438H19.0938Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6410_180169",
    x1: 11.75,
    y1: 38.9219,
    x2: 47,
    y2: 38.9219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6410_180169",
    x1: 0,
    y1: 23.5,
    x2: 26.4375,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsExcel);
export default __webpack_public_path__ + "static/media/ms_excel.da4e2ae2ef3f8320f3c6693f94b5210b.svg";
export { ForwardRef as ReactComponent };